import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

import { loginTypes } from 'config/loginTypes';
import useScrollElementOnMount from 'client/hooks/useScrollElementOnMount';
import Popup from 'client/components/Popup';
import LoginFacebook from 'client/components/dialogLogin/LoginFacebook';
import LoginLineContainer from 'client/components/dialogLogin/LoginLineContainer';
import LoginEnterprise from 'client/components/dialogLogin/LoginEnterprise';
import PrivacyLink from 'client/components/dialogLogin/PrivacyLink';

function DialogLogin({
    handleClose,
    title,
    footer,
    type,
    privacyUrl = false,
    privacyText = '',
    open
}) {
    const bindRef = useScrollElementOnMount();

    return (
        <Popup title={title} onClose={handleClose} isOpen={open}>
            <div css={contentStyle} ref={bindRef}>
                <div css={btnContainerStyle}>
                    {type === loginTypes.LINELOGIN && <LoginLineContainer />}
                    {type === loginTypes.FACEBOOKLOGIN && <LoginFacebook />}
                    {type === loginTypes.ENTERPRISELOGIN && <LoginEnterprise />}
                </div>
                {Boolean(privacyUrl) && (
                    <PrivacyLink privacyUrl={privacyUrl} privacyText={privacyText} />
                )}
            </div>
            <div css={footerStyle}>
                {Boolean(footer) && <Typography variant="caption">{footer}</Typography>}
            </div>
        </Popup>
    );
}

DialogLogin.propTypes = {
    handleClose: PropTypes.func,
    title: PropTypes.string,
    footer: PropTypes.string,
    type: PropTypes.number,
    privacyUrl: PropTypes.string,
    privacyText: PropTypes.string
};

export default DialogLogin;

const contentStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    text-align: center;
    padding: 24px 0;
`;

const btnContainerStyle = css`
    margin-bottom: 8px;
`;

const footerStyle = css`
    text-align: center;
    padding: 9.5px;
    min-height: 40px;
`;
